import styled from '@emotion/styled';

export const SelectButton = styled.button`
  width: 100%;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  height: 40px !important;
  padding: 0 12px !important;
  background: #ffffff !important;
  border: 1px solid #dcdcdc !important;
  border-radius: 12px !important;
  font-size: 12px !important;
  color: #737373 !important;
  font-family: 'Plus Jakarta Sans', sans-serif !important;
  cursor: pointer !important;
  white-space: nowrap !important;
  gap: 32px !important;

  @media (max-width: 768px) {
    gap: 0 !important;
  }

  &:hover {
    background: #f9f9f9;
  }

  &:focus {
    outline: none;
    border-color: #3d1690;
  }

  span {
    font-size: 8px;
    color: #737373;
    flex-shrink: 0;
  }

  &[as='select'] {
    appearance: none;
    padding-right: 30px;
    background-image: url("data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6L0.535898 0L7.4641 0L4 6Z' fill='%23737373'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 16px center;

    option {
      color: #2e2e2e;
      font-size: 14px;
    }

    option:first-of-type {
      color: #737373;
      font-size: 12px;
    }
  }
`;

// MultipleSelect 전용 옵션 리스트 (피그마 스타일 반영)
export const MultipleOptionList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 240px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const MultipleOptionCheckbox = styled.span<{ checked: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: ${({ checked }) => (checked ? 'none' : '2px solid #70737C')};
  border-radius: 8px;
  background: ${({ checked }) => (checked ? '#3D1690' : '#fff')};
  flex-shrink: 0;
  transition:
    border-color 0.15s,
    background 0.15s;
  box-sizing: border-box;
  min-width: 24px;
  min-height: 24px;

  svg {
    color: #fff;
    width: 20px;
    height: 20px;
  }
`;

export const MultipleOptionLabel = styled.span`
  flex: 1;
  font-size: 14px;
  color: #737373;
  font-family: 'Plus Jakarta Sans', sans-serif;
  text-align: left;
  font-weight: 400;
`;

export const MultipleOptionItem = styled.div<{ isSelected: boolean }>`
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
  text-align: left;
  cursor: pointer;
  font-size: 15px;
  color: #2e2e2e;
  font-family: 'Plus Jakarta Sans', sans-serif;
  transition:
    background 0.15s,
    color 0.15s;
  box-sizing: border-box;

  &:hover {
    background: #f5f5f7;
  }

  @media (max-width: 768px) {
  }
`;
